export const ScatterChartImg = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28.5" cy="32.5" r="1.5" fill="#1E78FF" />
    <circle cx="36.5" cy="32.5" r="1.5" fill="#DFECFF" />
    <circle cx="36.5" cy="28.5" r="1.5" fill="#DFECFF" />
    <circle cx="46.5" cy="13.5" r="1.5" fill="#DFECFF" />
    <circle cx="41.5" cy="30.5" r="1.5" fill="#DFECFF" />
    <circle cx="43.5" cy="25.5" r="1.5" fill="#1E78FF" />
    <circle cx="48.5" cy="25.5" r="1.5" fill="#1E78FF" />
    <circle cx="50.5" cy="20.5" r="1.5" fill="#DFECFF" />
    <circle cx="53.5" cy="18.5" r="1.5" fill="#DFECFF" />
    <circle cx="55.5" cy="14.5" r="1.5" fill="#DFECFF" />
    <circle cx="12.5" cy="54.5" r="1.5" fill="#DFECFF" />
    <circle cx="29.5" cy="38.5" r="1.5" fill="#DFECFF" />
    <circle cx="26.5" cy="45.5" r="1.5" fill="#1E78FF" />
    <circle cx="15.5" cy="46.5" r="1.5" fill="#DFECFF" />
    <circle cx="21.5" cy="40.5" r="1.5" fill="#1E78FF" />
    <circle cx="44.5" cy="29.5" r="1.5" fill="#1E78FF" />
    <circle cx="21.5" cy="44.5" r="1.5" fill="#DFECFF" />
    <circle cx="24.5" cy="39.5" r="1.5" fill="#1E78FF" />
    <circle cx="44.5" cy="42.5" r="1.5" fill="#DFECFF" />
    <circle cx="18.5" cy="21.5" r="1.5" fill="#1E78FF" />
    <circle cx="17.5" cy="48.5" r="1.5" fill="#DFECFF" />
    <circle cx="11.5" cy="49.5" r="1.5" fill="#DFECFF" />
  </svg>
);
